<template>
  <section
    data-component="hcAboutAlive"
    :data-visibility="visibility"
    class="about-subsection"
  >
    <template v-if="visibility === 'mobile'">
      <div class="graphic">
        <div class="quadrant-l">
          <div class="subquadrant-tl">
            <div class="placeholder yellow"></div>
            <img src="@/content/about/images/green_black.svg" alt="">
          </div>
          <div class="subquadrant-tr">
            <div class="placeholder blue"></div>
            <img src="@/content/about/images/face_lookingright.svg" alt="">
          </div>
          <div class="subquadrant-bl">
            <div class="placeholder blue"></div>
            <img src="@/content/about/images/blue_black.svg" alt="">
          </div>
          <div class="subquadrant-br">
            <div class="placeholder white"></div>
            <img src="@/content/about/images/white_black.svg" alt="">
          </div>
        </div>
        <div class="quadrant-r">
          <div class="placeholder yellow"></div>
          <img src="@/content/about/images/frontback.svg" alt="">
        </div>
      </div>
      <div class="content">
        <div class="content__container">
          <span>03</span>
          <h1 class="h1">
            Make it
            <br />
            Come to life
          </h1>
          <p>
            We’re not here to daydream. We live for real-world solutions, and once we get an idea rolling, we launch into its building and development. Our world-class engineers work with clients at every stage of prototyping, software design, and engineering to bring a possibility to the here and now.
          </p>
          <div class="headline">
            <span data-ornament="rectangle" />
            <h2 class="h2">
              Services
            </h2>
          </div>
          <ul class="services">
            <li class="service">Prototyping</li>
            <li class="service">Front-End Development</li>
            <li class="service">Mobile Development</li>
            <li class="service">Back-End Development</li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content__anchor" id="hcAboutAlive"></div>
      <ScrollItem :id="`aboutAlive_component_top`">
        <div data-anchor="aboutAlive_component_top"></div>
      </ScrollItem>
      <div class="content" :class="contentFixed">
        <div class="content__container" :style="contentOpacity">
        <span class="tab-number">03</span>
        <h1 class="h1">
          Make it
          <br />
          Come to life
        </h1>
        <p>
          We’re not here to daydream. We live for real-world solutions, and once we get an idea rolling, we launch into its building and development. Our world-class engineers work with clients at every stage of prototyping, software design, and engineering to bring a possibility to the here and now.
        </p>
        <div class="headline">
          <span data-ornament="rectangle" />
          <h2 class="h2">
            Services
          </h2>
        </div>
        <ul class="services">
          <li class="service">Prototyping</li>
          <li class="service">Front-End Development</li>
          <li class="service">Mobile Development</li>
          <li class="service">Back-End Development</li>
        </ul>
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility === 'compact'">
        <div class="quadrant-t">
          <div class="placeholder blue"></div>
          <img src="@/content/about/images/eureka_tall.svg" alt="">
        </div>
        <div class="quadrant-b">
          <div class="placeholder yellow"></div>
          <img src="@/content/about/images/frontback.svg" alt="">
        </div>
      </div>
      <div class="graphic" :class="graphicFixed" v-if="visibility === 'full'">
        <div class="quadrant-tl">
          <div class="placeholder blue"></div>
            <img src="@/content/about/images/eureka_tall.svg" alt="">
        </div>
        <div class="quadrant-tr">
          <div class="placeholder black"></div>
            <img src="@/content/about/images/codeline_tall.svg" alt="">
        </div>
        <div class="quadrant-bl">
          <div class="placeholder white"></div>
          <img src="@/content/about/images/stack.svg" alt="">
        </div>
        <div class="quadrant-br">
          <div class="placeholder yellow"></div>
          <img src="@/content/about/images/frontback.svg" alt="">
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'component_hcAboutAlive',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function() {
      let opacity = 0;
      let pointerEvents = 'none';

      const percentScrolled = this.percentScrolled;

      if (percentScrolled < 325) {
        opacity = 0;
        pointerEvents = 'none';
      } else if (percentScrolled < 350) {
        opacity = (percentScrolled - 325) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 375) {
        opacity = 1;
        pointerEvents = 'auto';
      } else {
        opacity = 1 - ((percentScrolled - 375) / 25);
        opacity = Math.max(0, opacity);
        pointerEvents = 'none';
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents,
      };
    },
    graphicFixed: function () {
      const classes = {
        following: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.aboutAlive_component_top;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function() {
      const classes = {
        fixed: false,
        'fixed--bottom': false,
      };

      const top = this.scrollState.topOfAboutContent;
      const bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

[data-component="hcAboutAlive"] {
  [data-anchor="aboutAlive_component_top"] {
    position: absolute;
    top: 0;
  }

  &[data-visibility="mobile"] {
    .graphic {
      .quadrant-l {
        grid-column: 1 / span 1;
        
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;

        .subquadrant-tl {
          grid-column: 1 / span 1;
          grid-row:  1 / span 1;
        @include imageRatio();
        }

        .subquadrant-tr {
          grid-column: 2 / span 1;
          grid-row: 1 / span 1;
        }

        .subquadrant-bl {
          grid-column: 1 / span 1;
          grid-row: 2 / span 1;
        }

        .subquadrant-br {
          grid-column: 2 / span 1;
          grid-row: 2 / span 1;
        }
      }

      .quadrant-r {
        grid-column: 2 / span 1;
      }
    }
  }

  &[data-visibility="compact"] {
    height: 125vh;
    
    .graphic {
      .quadrant-t {
        grid-column: 1 / span 2;
        grid-row: 1 / span 3;
      }

      .quadrant-b {
        grid-column: 1 / span 2;
        grid-row: 4 / span 2;
      }
    }
  }

  &[data-visibility="full"] {
    height: 125vh;
    
    .graphic {
      .quadrant-tl {
        @include imageRatio(1.5);
        grid-column: 1 / span 1;
        grid-row: 1 / span 3;
      }

      .quadrant-tr {
        grid-column: 2 / span 1;
        grid-row: 1 / span 3;
      }

      .quadrant-bl {
        grid-column: 1 / span 1;
        grid-row: 4 / span 2;

        display: grid;
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(2, 1fr);

        .subquadrant-tl {
          grid-row: 1 / span 1;
          grid-column: 1 / span 1;
        }

        .subquadrant-tr {
          grid-row: 1 / span 1;
          grid-column: 2 / span 1;
        }

        .subquadrant-bl {
          grid-row: 2 / span 1;
          grid-column: 1 / span 1;
        }

        .subquadrant-br {
          grid-row: 2 / span 1;
          grid-column: 2 / span 1;
        }
      }

      .quadrant-br {
        grid-column: 2 / span 1;
        grid-row: 4 / span 2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/int_hcAboutAlive.vue